<div class="direccion-compra-mobile-wrapper">
    <app-direccion-compra-view></app-direccion-compra-view>
</div>